import { Session } from 'sip.js';
import { Store } from 'vuex';
import { setupRemoteMedia } from './setupRemoteMedia';

export const createSessionDelegates = (session: Session, store: Store<any>) => {
    return {
        onMessage: (msg: any) => {
            console.log("INCOMING IN DIALOG MESSAGE");
            console.dir(msg);

            (session as any).messages.push(msg);
            store.commit('sip/forceSessionsUpdate');
            msg.accept();

            const m = JSON.parse(msg.request.body);
            console.dir(m);

            if (m.type === 'videoEnable' && m.state === true) (session as any).videoEnable = true;
            if (m.type === 'videoEnable' && m.state === false) (session as any).videoEnable = false;

        },
        onInvite: (request: any, response: any, statusCode: any) => {
            // Remote media setup is now handled once in the sessionListener at
            // the beginning of a call (sessionListener.ts), and then again in
            // peerConnection.ontrack() which is initialized in setupRemoteMedia.{js|ts}
        }
    }
}
